/* global ScrollTrigger */
import {
    $, addAction, INIT, HASH_STATE_CHANGE,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    // Initialize GSAP and ScrollTrigger
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        // Animate hero trees - initial slide down from top to bottom
        const $trees = $('.hero-202602__trees');
        if ($trees.length) {
            const treesElement = $trees[0];
            // Calculate how far up the trees need to start (at top of viewport)
            // Since trees are positioned at bottom: 0, we need negative Y to move them up
            const viewportHeight = window.innerHeight;
            const treesHeight = treesElement.offsetHeight;
            const startY = -(viewportHeight - treesHeight);
            // Initial animation: slide down from top to bottom of viewport
            gsap.fromTo(
                treesElement,
                { y: 0 },
                {
                    y: 30,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: '.hero-202602',
                        start: 'top top',
                        end: 'bottom top',
                        scrub: 1,
                        invalidateOnRefresh: true,
                    },
                },
            );
        }

        // Parallax scroll effect for sky (faster movement for depth)
        const $sky = $('.hero-202602__sky-bg');
        if ($sky.length) {
            const skyElement = $sky[0];
            gsap.to(skyElement, {
                y: 200,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.hero-202602',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1,
                    invalidateOnRefresh: true,
                },
            });
        }

        // Parallax scroll effect for ocean (fast movement for depth)
        const $ocean = $('.hero-202602__ocean');
        if ($ocean.length) {
            const oceanElement = $ocean[0];
            gsap.to(oceanElement, {
                y: 150,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.hero-202602',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1,
                    invalidateOnRefresh: true,
                },
            });
        }

        // Create and animate star bursts by cloning existing star element
        const $hero = $('.hero-202602__sky');
        const $starTemplate = $('.hero-202602__star');
        if ($hero.length && $starTemplate.length) {
            const heroElement = $hero[0];
            const numStars = 50;
            // Hide the original template star
            $starTemplate[0].style.display = 'none';

            for (let i = 0; i < numStars; i++) {
                // Clone the template star
                const star = $starTemplate[0].cloneNode(true);
                star.style.display = '';

                // Add desktop-only class to half the stars
                if (i >= 25) {
                    star.classList.add('hero-202602__star--desktop');
                }

                // Random position (avoid edges, top 50% only)
                const randomX = Math.random() * 95 + 5; // 5% to 95%
                const randomY = Math.random() * 40 + 0; // 0% to 50%
                star.style.left = `${randomX}%`;
                star.style.top = `${randomY}%`;
                // Random animation delay for staggered effect
                const randomDelay = Math.random() * 2;
                star.style.animationDelay = `${randomDelay}s`;
                // Random animation duration for variety
                const randomDuration = 2.5 + Math.random() * 1.5; // 2.5s to 4s
                star.style.animationDuration = `${randomDuration}s`;
                heroElement.appendChild(star);
            }
        }
    }
});
// EXAMPLE OF HOW TO USE:
// const easeOutExpo = (x) => (x === 1 ? 1 : 1 - 2 ** (-10 * x));
// const maxTime = 1000;
// const easeRate = 20;
// /* eslint-disable no-param-reassign */
// const processBatch = (batch, add) => {
//     window.requestAnimationFrame(() => {
//         batch.forEach((element, index) => {
//             if (add) {
//                 const delay = Math.round(maxTime * easeOutExpo(index / easeRate)) + 200;
//                 if (delay) {
//                     element.style.transitionDelay = `${delay}ms`;
//                 }
//                 element.classList.add('animate-to');
//                 element.classList.remove('animate-from');
//             } else {
//                 element.style.transitionDelay = '';
//                 element.classList.add('animate-from');
//                 element.classList.remove('animate-to');
//             }
//         });
//     });
// };
// const forceUpdate = () => {
//     setTimeout(() => {
//         window.requestAnimationFrame(() => {
//             ScrollTrigger.refresh(false);
//             ScrollTrigger.update();
//         });
//     }, 0);
// };
// /* eslint-enable no-param-reassign */
// const selectors = ['.content-section__container'];
// addAction(INIT, () => {
//     $(selectors.join(', ')).addClass('animate-from');
//     ScrollTrigger.batch(selectors.join(', '), {
//         onEnter: (batch) => processBatch(batch, true),
//         // onLeave: (batch) => processBatch(batch, false),
//         // onEnterBack: (batch) => processBatch(batch, true),
//         onLeaveBack: (batch) => processBatch(batch, false),
//     });
//     addAction('updateScrollTrigger', forceUpdate);
//     addAction(HASH_STATE_CHANGE, forceUpdate);
//     addAction('toggleTrigger', ($targets) => {
//         const elements = $targets
//             .find('.animate-to')
//             .filter((i, el) => SetDesign.viewport.isInViewport(el))
//             .get();
//         if (elements.length) {
//             processBatch(elements, false);
//             window.requestAnimationFrame(() => {
//                 processBatch(elements, true);
//             });
//         }
//     });
// });
